import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'form',
    'typeField',
    'question',
    'questionNumberTitle',
    'questionNumberInput',
    'questionRemoveButton',
    'totalPoint',
    'point',
  ];

  static values = {
   formPath: String,
   questionChoicesFormPath: String,
  };

  connect() {
    this.calcTotalPoint();
  }

  async typeChanged() {
    const formData = new FormData(this.formTarget);
    formData.set('_method', 'POST');

    const response = await fetch(this.formPathValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
      },
      body: formData,
    });

    const html = await response.text();
    window.Turbo.renderStreamMessage(html);
  }

  async reloadQuestionChoicesForm(event) {
    const questionChoicesForm = event.target.closest('.question_choices_form');
    const formData = new FormData();

    // NOTE: question_choices_form の再描画に type(単問式、複数問式）は不要に思うが、formの name属性の作りが変わるため、現時点の type を正しくセットする必要がある。
    formData.append('type', this.typeFieldTarget.type === 'hidden' ? this.typeFieldTarget.value : this.typeFieldTargets.find(e => e.checked).value);

    questionChoicesForm.querySelectorAll('input[type="hidden"], input[type="text"], input[type="radio"]:checked, select').forEach(e => {
      formData.append(e.name, e.value);
    });

    const response = await fetch(this.questionChoicesFormPathValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
      },
      body: formData,
    });

    const html = await response.text();
    window.Turbo.renderStreamMessage(html);
  }

  toggleRemoveButton() {
    const allowRemove = this.questionTargets.length > 1;

    this.questionRemoveButtonTargets.forEach(e => e.hidden = !allowRemove); 
  }

  removeQuestion(event) {
    if (confirm("設題を削除しますか？")) {
      this.questionTargets.at(
        this.questionRemoveButtonTargets.indexOf(event.target)
      ).remove();
    }
  }

  questionTargetConnected() {
    this.setQuestionNumber();
    this.toggleRemoveButton();
  }

  questionTargetDisconnected() {
    this.setQuestionNumber();
    this.toggleRemoveButton();
    this.calcTotalPoint();
  }

  calcTotalPoint() {
    if (!this.hasTotalPointTarget) return;

    this.totalPointTarget.textContent = this.pointTargets.reduce((acc, e) => acc + Number(e.value), 0);
  }

  setQuestionNumber() {
    this.questionTargets.forEach((_e, i) => {
      this.questionNumberTitleTargets.at(i).textContent = i + 1;
      this.questionNumberInputTargets.at(i).value = i + 1;
    });
  }
}
